import VipPopup from '../components/VipPopup';
import ProductOffer from "../components/ProductOffer";

export default (function (w, d) {
    'use strict';

    function HomeController() {
        new VipPopup();
        new ProductOffer(false);
        this.initCarousels();
    }

    HomeController.prototype.initCarousels = function () {
        $('.product_slider').slick({
            centerPadding: '0px',
            slidesToShow: 5,
            infinite: true,
            prevArrow: "<button type='button' class='slider-prev'><img class='clickable' style='transform: rotate(180deg);' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            nextArrow: "<button type='button' class='slider-next'><img class='clickable' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        infinite: true,
                        prevArrow: "",
                        nextArrow: "",
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        infinite: true,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1500,
                    settings: {
                        infinite: true,
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                    }
                }
            ]
        });

        $('.index_page_bigger_slider').slick({
            // centerMode: true,
            focusOnSelect: true,
            centerPadding: '0px',
            slidesToShow: 3,
            // initialSlide: 1,
            prevArrow: "<button type='button' class='slider-prev'><img class='clickable' style='transform: rotate(180deg);' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            nextArrow: "<button type='button' class='slider-next'><img class='clickable' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                    }
                },
            ]
        });

        $('.index_page_top_slider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: '0px',
            infinite: true,
            prevArrow: "<button type='button' class='slider-prev'><img class='clickable' style='transform: rotate(180deg);' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
            nextArrow: "<button type='button' class='slider-next'><img class='clickable' src='/assets/build/images/icons/icon_arrow_big.svg'></button>",
        });
    }

    return HomeController;
}(window, document));

